const initialState = {
  achInstitution: null,
  invalid: null,
  isRetiredLakeTrustRoutingNumber: false
};

export function achInstitution(state = initialState, action) {
  switch (action.type) {
    case "SEARCH_FOR_INSTITUTION":
      return state;
    case "INVALID_ACH_INSTITUTION":
      return { ...state, invalid: true };
    case "SET_INSTITUTION":
      return { ...state, achInstitution: action.payload.Name, invalid: action.payload.IsRetiredLakeTrustRoutingNumber, isRetiredLakeTrustRoutingNumber: action.payload.IsRetiredLakeTrustRoutingNumber };
    case "CLEAR_ACH_INSTITUTION":
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/achInstitution.js